import { render, staticRenderFns } from "./StatementsMenu.vue?vue&type=template&id=cc51e186"
import script from "./StatementsMenu.vue?vue&type=script&lang=js"
export * from "./StatementsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports